import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import axios from 'axios'

// Determine the appropriate API URL based on the environment
const determineBaseUrl = () => {
  // First check for explicit environment variable
  const envApiUrl = import.meta.env.VITE_API_URL;
  if (envApiUrl) {
    console.log(`[API] Using API URL from environment: ${envApiUrl}`);
    return envApiUrl;
  }
  
  // For development, use the current protocol and hostname
  if (import.meta.env.DEV) {
    // Always use the same protocol as the page for API requests
    return `${window.location.protocol}//${window.location.host}/api`;
  }
  
  // Use environment variable if available
  const publicApiUrl = import.meta.env.VITE_PUBLIC_API_URL;
  
  if (publicApiUrl) {
    // If it includes protocol, use as is
    if (publicApiUrl.includes('://')) {
      return `${publicApiUrl}/api`;
    }
    // Always use HTTPS protocol
    return `https://${publicApiUrl}/api`;
  }
  
  // Default to relative URL for same-origin requests
  return '/api';
};

const baseURL = determineBaseUrl();
axios.defaults.baseURL = baseURL;
console.log(`[API] Setting global axios default baseURL: ${baseURL}`);

// Disable StrictMode in development to prevent double-mounting
// This helps prevent the login page from remounting repeatedly
ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
)
